import api from './axios';

// Team CRUD
export const getTeams = async (department = null, activeOnly = true) => {
  const params = new URLSearchParams();
  if (department) params.append('department', department);
  params.append('activeOnly', activeOnly);
  const response = await api.get(`/api/teams?${params.toString()}`);
  return response.data;
};

export const getTeamById = async (teamId) => {
  const response = await api.get(`/api/teams/${teamId}`);
  return response.data;
};

export const getTeamsByLead = async (leadUserId) => {
  const response = await api.get(`/api/teams/by-lead/${leadUserId}`);
  return response.data;
};

export const getMyTeams = async () => {
  const response = await api.get('/api/teams/my-teams');
  return response.data;
};

export const createTeam = async (request) => {
  const response = await api.post('/api/teams', request);
  return response.data;
};

export const updateTeam = async (teamId, request) => {
  const response = await api.put(`/api/teams/${teamId}`, request);
  return response.data;
};

export const deleteTeam = async (teamId) => {
  const response = await api.delete(`/api/teams/${teamId}`);
  return response.data;
};

// Team Membership
export const getTeamMembers = async (teamId, activeOnly = true) => {
  const params = new URLSearchParams();
  params.append('activeOnly', activeOnly);
  const response = await api.get(`/api/teams/${teamId}/members?${params.toString()}`);
  return response.data;
};

export const addTeamMember = async (teamId, userId) => {
  const response = await api.post(`/api/teams/${teamId}/members`, { userId });
  return response.data;
};

export const removeTeamMember = async (teamId, userId) => {
  const response = await api.delete(`/api/teams/${teamId}/members/${userId}`);
  return response.data;
};

// Organization Hierarchy
export const getOrganizationalHierarchy = async () => {
  const response = await api.get('/api/teams/hierarchy');
  return response.data;
};

export const getMyHierarchy = async () => {
  const response = await api.get('/api/teams/my-hierarchy');
  return response.data;
};

export const getTeamHierarchy = async (teamId) => {
  const response = await api.get(`/api/teams/${teamId}/hierarchy`);
  return response.data;
};

export const getActiveTeamLookups = async () => {
  const response = await api.get('/api/teams/lookup');
  return response.data;
};

// Team Overview (clock-in status)
export const getTeamOverview = async () => {
  const response = await api.get('/api/teams/overview');
  return response.data;
};

// Member detailed stats
export const getMemberStats = async (userId) => {
  const response = await api.get(`/api/teams/member-stats/${userId}`);
  return response.data;
};
